import cartoon from "../src/cartoon.png";
import computer from "../src/computer.png";
import geo from "../src/geo.png";
import math from "../src/math.png";
import music from "../src/music.png";
import sports from "../src/sports.png";

const Categories = [
  {
    category: "Music",
    value: 12,
    image: music,
  },
  {
    category: "Computer",
    value: 18,
    image: computer,
  },
  {
    category: "Mathematics",
    value: 19,
    image: math,
  },
  {
    category: "Sports",
    value: 21,
    image: sports,
  },
  {
    category: "Geography",
    value: 22,
    image: geo,
  },
  {
    category: "Cartoon and Animations",
    value: 32,
    image: cartoon,
  },
];

export default Categories;
